import { render, staticRenderFns } from "./DrawResult.vue?vue&type=template&id=d6011150"
import script from "./DrawResult.vue?vue&type=script&lang=js"
export * from "./DrawResult.vue?vue&type=script&lang=js"
import style0 from "./DrawResult.vue?vue&type=style&index=0&id=d6011150&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports